import React from 'react';
import Button from './Button';

const Banner = ({
  backgroundImage,
  title,
  description,
  buttonText,
  buttonLink,
  buttonVariant = 'secondary',
  overlayGradient = 'from-purple-900/90 via-purple-900/70 to-orange-500/60',
  className = '',
}) => {
  return (
    <div className="px-6 py-12 mx-auto max-w-7xl sm:py-16 lg:px-8">
      <div className={`relative isolate overflow-hidden rounded-3xl ${className}`}>
        {/* Background Image */}
        <img
          src={backgroundImage}
          alt=""
          className="absolute inset-0 object-cover w-full h-full -z-10"
        />

        {/* Gradient Overlay */}
        <div className={`absolute inset-0 -z-10 bg-gradient-to-r ${overlayGradient}`} />

        {/* Content */}
        <div className="px-6 py-24 sm:py-32 lg:px-8">
          <div className="max-w-2xl mx-auto text-center">
            <h1 className="text-4xl font-bold tracking-tight text-white sm:text-6xl">
              {title}
            </h1>
            <p className="mt-6 text-lg leading-8 text-gray-100">
              {description}
            </p>
            {buttonText && (
              <div className="mt-10">
                <Button
                  variant={buttonVariant}
                  size="lg"
                  href={buttonLink}
                >
                  {buttonText}
                </Button>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Banner;
